import React, { useState, useEffect } from 'react';
import { api } from './api.js';
import styles from './Sectors.module.css';
import { hasPermission, PERMISSIONS, getUserData } from './permissions';

const Sectors = () => {
  const [sectores, setSectores] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [afiliados, setAfiliados] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [selectedSector, setSelectedSector] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedManager, setSelectedManager] = useState(null);

  useEffect(() => {
    const userData = getUserData();
    setIsAdmin(userData?.rol === 'administrador');

    const fetchData = async () => {
      try {
        const [sectoresData, usuariosData, afiliadosData] = await Promise.all([
          api.getSectors(),
          api.getUsers(),
          api.getAfiliados()
        ]);

        setSectores(Array.isArray(sectoresData) ? sectoresData : []);
        setUsuarios(Array.isArray(usuariosData) ? usuariosData : []);
        setAfiliados(Array.isArray(afiliadosData) ? afiliadosData : []);
        
        console.log('Sectores:', sectoresData);
        console.log('Usuarios:', usuariosData);
        console.log('Afiliados:', afiliadosData);
      } catch (error) {
        console.error('Error al obtener los datos:', error);
      }
    };

    fetchData();
  }, []);

  const handleDeleteUser = async (userId) => {
    // Verificar si el usuario actual es administrador
    const userRole = localStorage.getItem('userRole');
    
    if (userRole !== 'administrador') {
      alert('Solo los administradores pueden eliminar usuarios');
      return;
    }

    if (window.confirm('¿Estás seguro de que deseas eliminar este usuario?')) {
      try {
        await api.deleteUser(userId);
        setUsuarios(usuarios.filter(user => user.id !== userId));
        alert('Usuario eliminado exitosamente');
      } catch (error) {
        console.error('Error al eliminar usuario:', error);
        alert('Error al eliminar usuario');
      }
    }
  };

  const handleDeleteSector = async (sectorId) => {
    if (window.confirm('¿Estás seguro de que deseas eliminar este sector?')) {
      try {
        await api.deleteSector(sectorId);
        setSectores(sectores.filter(sector => sector.id !== sectorId));
        alert('Sector eliminado exitosamente');
      } catch (error) {
        console.error('Error al eliminar sector:', error);
        alert('Error al eliminar sector');
      }
    }
  };

  const handleSectorClick = (sector) => {
    setSelectedSector(sector);
    setShowDetails(true);
  };

  const handleBackClick = () => {
    setShowDetails(false);
    setSelectedSector(null);
  };

  const handleManagerClick = (usuario) => {
    if (usuario.rol === 'encargado') {
      setSelectedManager(usuario);
    }
  };

  const handleBackToSector = () => {
    setSelectedManager(null);
  };

  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    const sectorName = selectedSector.nombre_sector;
    const afiliadosEnSector = afiliados.filter(
      (afiliado) => afiliado.sector === selectedSector.nombre_sector
    );
    const totalAfiliados = afiliadosEnSector.length;
    
    printWindow.document.write(`
      <html>
        <head>
          <title>Reporte de Sector</title>
          <style>
            body { font-family: Arial, sans-serif; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #003366; color: white; }
            .header { text-align: center; margin-bottom: 20px; }
            .summary { margin: 20px 0; }
          </style>
        </head>
        <body>
          <div class="header">
            <h2>Reporte de Sector: ${sectorName}</h2>
          </div>
          <div class="summary">
            <p><strong>Total de Afiliados:</strong> ${totalAfiliados}</p>
            <p><strong>Fecha de Impresión:</strong> ${new Date().toLocaleDateString()}</p>
          </div>
          <table>
            <thead>
              <tr>
                <th>Código</th>
                <th>Nombres</th>
                <th>Apellidos</th>
                <th>Cédula</th>
                <th>Teléfono</th>
                <th>Monto</th>
              </tr>
            </thead>
            <tbody>
              ${afiliadosEnSector.map(afiliado => `
                <tr>
                  <td>${afiliado.codigoAfiliado}</td>
                  <td>${afiliado.nombresTitular}</td>
                  <td>${afiliado.apellidosTitular}</td>
                  <td>${afiliado.cedulaTitular}</td>
                  <td>${afiliado.telefonoTitular}</td>
                  <td>${afiliado.totalPagarMensual}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  if (showDetails && selectedSector) {
    const afiliadosEnSector = afiliados.filter(
      (afiliado) => afiliado.sector === selectedSector.nombre_sector
    );

    if (selectedManager) {
      const afiliadosDelEncargado = usuarios.filter(
        (usuario) => usuario.sector_id === selectedSector.id && usuario.rol === 'usuario'
      );

      return (
        <div className={styles.sectorsContainer}>
          <div className={styles.headerSection}>
            <button className={styles.backButton} onClick={handleBackToSector}>
              Volver al Sector
            </button>
            <h2>Afiliados del Encargado: {selectedManager.nombre} {selectedManager.apellido}</h2>
          </div>
          <div className={styles.tableWrapper}>
            <table className={styles.sectorsTable}>
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Apellido</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {afiliadosDelEncargado.length > 0 ? (
                  afiliadosDelEncargado.map((afiliado) => (
                    <tr key={afiliado.id}>
                      <td>{afiliado.nombre}</td>
                      <td>{afiliado.apellido}</td>
                      <td>{afiliado.estado || 'Activo'}</td>
                      <td>
                        <button
                          className={styles.deleteButton}
                          onClick={() => handleDeleteUser(afiliado.id)}
                        >
                          Eliminar
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4">No hay afiliados asignados a este encargado</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.sectorsContainer}>
        <div className={styles.headerSection}>
          <button className={styles.backButton} onClick={handleBackClick}>
            Volver
          </button>
          <h2>Sector: {selectedSector.nombre_sector}</h2>
          <button className={styles.printButton} onClick={handlePrint}>
            Imprimir Reporte
          </button>
        </div>
        <div className={styles.tableWrapper}>
          <table className={styles.sectorsTable}>
            <thead>
              <tr>
                <th>Código</th>
                <th>Nombres</th>
                <th>Apellidos</th>
                <th>Cédula</th>
                <th>Teléfono</th>
                <th>Monto</th>
              </tr>
            </thead>
            <tbody>
              {afiliadosEnSector.length > 0 ? (
                afiliadosEnSector.map((afiliado) => (
                  <tr key={afiliado.id}>
                    <td>{afiliado.codigoAfiliado}</td>
                    <td>{afiliado.nombresTitular}</td>
                    <td>{afiliado.apellidosTitular}</td>
                    <td>{afiliado.cedulaTitular}</td>
                    <td>{afiliado.telefonoTitular}</td>
                    <td>{afiliado.totalPagarMensual}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No hay afiliados en este sector</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.sectorsContainer}>
      <h2 className={styles.sectorsTitle}>Sectores</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.sectorsTable}>
          <thead>
            <tr>
              <th>Nombre del Sector</th>
              <th>Total Afiliados</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {sectores.map((sector) => {
              const totalAfiliados = afiliados.filter(
                (afiliado) => afiliado.sector === sector.nombre_sector
              ).length;
              return (
                <tr key={sector.id} onClick={() => handleSectorClick(sector)} className={styles.clickableRow}>
                  <td>{sector.nombre_sector}</td>
                  <td>{totalAfiliados}</td>
                  <td>
                    {isAdmin && (
                      <button
                        className={styles.deleteButton}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteSector(sector.id);
                        }}
                      >
                        Eliminar Sector
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Sectors;
